module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hans/1-3cfbdb4c45faa2265af574bc7afba5e4.jpg";